/* eslint-disable react/jsx-props-no-spreading */
import { Filter, Form } from '@/components'
import { singularStatusMapLabel } from '@/constants/castration'
import PropTypes from 'prop-types'
import React from 'react'
// import { Container } from './styles';

function FilterCastrations({ dateRef, lockDateRef }) {
  return (
    <Filter
      key={`filter-${dateRef}`}
      initialValues={{
        dateRef: dateRef || '',
        datePeriod: [null, null],
        animalCategoryId: '',
        animalGender: '',
        statusCastration: '',
      }}
      title="Filtrar castrações"
      renderForm={({ values }) => (
        <>
          <div className="divider text-center" data-content="Períodos" />
          {!lockDateRef ? (
            <Form.Group>
              <Form.Label className="text-sm" htmlFor="dateRef">
                Selecione o período de referência para o filtro
              </Form.Label>
              <Form.ValidationField name="dateRef">
                {({ field }) => (
                  <Form.Select
                    {...field}
                    id="dateRef"
                    className="select-sm"
                    placeholder="Data de referência"
                  >
                    <option
                      value=""
                      disabled
                      className="text-italic text-gray-500"
                    >
                      Selecione
                    </option>
                    <option value="createdAt">Solicitado em</option>
                    <option value="preApprovedAt">Pré aprovado em</option>
                    <option value="approvedAt">Aprovado em</option>
                    <option value="scheduledTo">Agendado para</option>
                    <option value="startedAt">Iniciado em</option>
                    <option value="performedAt">Finalizado em</option>
                    <option value="rejectedAt">Rejeitado em</option>
                    <option value="canceledAt">Cancelado em</option>
                  </Form.Select>
                )}
              </Form.ValidationField>
            </Form.Group>
          ) : null}
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="datePeriod">
              De - Até
            </Form.Label>
            <Form.DatePickerField
              placeholderText="Data início - Data fim"
              dateFormat="dd/MM/yyyy"
              startDate={
                values.datePeriod?.[0] ? new Date(values.datePeriod[0]) : null
              }
              endDate={
                values.datePeriod?.[1] ? new Date(values.datePeriod[1]) : null
              }
              className="form-input input-sm"
              selectsRange
              isClearable
              disabled={!values.dateRef}
              name="datePeriod"
            />
          </Form.Group>
          <div className="divider text-center" data-content="Animal" />
          <Form.Group>
            <Form.Label htmlFor="animalCategoryId">Espécie do pet</Form.Label>
            <Form.ValidationField name="animalCategoryId">
              {
                ({ field }) => (
                  <Form.Select
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    id="animalCategoryId"
                    className="select-sm"
                    placeholder="Espécie do pet"
                  >
                    <option value="">Todos</option>
                    <option value="1">Cachorro</option>
                    <option value="2">Gato</option>
                  </Form.Select>
                )
              }
            </Form.ValidationField>
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="animalGender">Gênero do pet</Form.Label>
            <Form.ValidationField name="animalGender">
              {
                ({ field }) => (
                  <Form.Select
                    {...field}
                    id="animalGender"
                    className="select-sm"
                    placeholder="Gênero do pet"
                  >
                    <option value="">Todos</option>
                    <option value="male">Macho</option>
                    <option value="female">Fêmea</option>
                  </Form.Select>
                )
              }
            </Form.ValidationField>
          </Form.Group>
          <div className="divider text-center" data-content="Castração" />
          <Form.Group>
            <Form.Label htmlFor="statusCastration">Status</Form.Label>
            <Form.ValidationField name="statusCastration">
              {({ field }) => (
                <Form.Select
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...field}
                  id="statusCastration"
                  className="select-sm"
                  placeholder="Status da castração"
                >
                  <option value="">Todos</option>
                  {Object.keys(singularStatusMapLabel).map((status) => (
                    <option key={status} value={status}>
                      {singularStatusMapLabel[status]}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Form.ValidationField>
          </Form.Group>
        </>
      )}
    />
  )
}

FilterCastrations.propTypes = {
  dateRef: PropTypes.string,
  lockDateRef: PropTypes.bool,
}

FilterCastrations.defaultProps = {
  dateRef: '',
  lockDateRef: false,
}

export default FilterCastrations
